import React from 'react';
import { isNullOrUndefined } from 'utils/Global';

export default function RMCheckBox({
  isChecked,
  isDisabled = false,
  onChange,
  style = null,
  className = null,
  name = '',
  width = '',
  height = '',
}) {
  function onClickCheckbox(e) {
    if (!isNullOrUndefined(onChange)) {
      onChange(e);
    }
  }
  return (
    <input
      id="controls-rmcheckbox-input-component"
      data-testid="controls-rmcheckbox-input-component"
      style={{ ...style, width: '24px', height: '24px' }}
      type="checkbox"
      className={className + ' checkboxcheckmark inline'}
      name={name}
      onChange={onClickCheckbox}
      defaultChecked={isChecked}
      disabled={isDisabled}
      checked={isChecked}
    />
  );
}

export const RMCheckBoxY = ({
  isChecked,
  onChange,
  width = '30',
  height = '30.5',
  disabled = false,
  style = {},
  className = '',
}) => {
  const btnOff = (
    <svg
      id="controls-rmcheckbox-y-svg-buttonoff"
      data-testid="controls-rmcheckbox-y-svg-buttonoff"
      width={width}
      height={height}
      viewBox="0 0 48 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        id="controls-rmcheckbox-y-rect-buttonoff"
        data-testid="controls-rmcheckbox-y-rect-buttonoff"
        x="12.5"
        y="12.6829"
        width="23"
        height="23"
        fill={disabled ? '#EDEDED' : '#FFF'}
        stroke="#303030"
      />
      {}
    </svg>
  );

  const btnOn = (
    <svg
      id="controls-rmcheckbox-y-svg-buttonon"
      data-testid="controls-rmcheckbox-y-svg-buttonon"
      width={width}
      height={height}
      viewBox="0 0 48 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        id="controls-rmcheckbox-y-rect-buttonon"
        data-testid="controls-rmcheckbox-y-rect-buttonon"
        x="12.5"
        y="12.6829"
        width="23"
        height="23"
        fill={disabled ? '#F7A24680' : '#F7A246'}
        stroke="#303030"
      />
      <path
        id="controls-rmcheckbox-y-path-buttonon"
        data-testid="controls-rmcheckbox-y-path-buttonon"
        d="M15 25.1829L17 23.1829L21 27.1829L31 17.1829L33 19.1829L21 31.1829L15 25.1829Z"
        fill="white"
      />
    </svg>
  );
  const handleToggle = () => {
    if (!disabled && !isNullOrUndefined(onChange)) {
      onChange(!isChecked);
    }
  };

  return (
    <div
      id="controls-rmcheckbox-pointer"
      data-testid="controls-rmcheckbox-pointer"
      style={{ cursor: 'pointer' }}
      className={className}
      onClick={handleToggle}
    >
      {isChecked ? btnOn : btnOff}
    </div>
  );
};
